/*
Sai maheshwar 01/04/2023 2701334326 Add Record Group
dilip 01/08/2023 2701334326 Added Completed steps functionality
dilip 01/10/2023 2701334326 Added unsaved popup.
kavyareddy 01/10/2023 2701334326 Added download configuration
Sohel 01/10/2023 2699714747 changed download configuration condition
Sohel 01/12/2023 2699299906 Added download configuration condition
Sohel 01/19/2023 2699714747 Download Configuration payload changes
Sohel 01/20/2023 2789725780 Added LastStep in payload
Sohel 01/22/2023 2789725780 Added preprocessor Field and Add preprocessor Group step
Sohel 01/25/2023 2698964415 completed Status changes
Ashraf 01/27/2023 2698964415 conditional render of audit fields
Sohel 01/31/2023 2698964415 payload changes
sai krishna 01/16/2023 2698964415  updated download configuration payload
Sohel 01/08/2023 2701335619 implemented Usage Functionality
Sohel 01/08/2023 2701335619 Fixed Download Usage Configuration Issue
Rohini 02/09/2023 2701335619 added classnames for buttons
Akhila 02/24/2023 2701335619 implemented preview file functionality in download configuration
Ravi 03/01/2023 2701335619 Added loader and download toast message for preview File
Sohel 03/10/2023 2701335619 added StepIconComponent for showing Numbers in StepLabel
Raghu 03/20/2023 2701335619 fixed stepper header in responsive
 Prakash 24/04/2023 2701335619 fixed stepper issue in tab view
Ravi 06/09/2023 2701335619 Added Breadcrums in preview
Akhila 06/12/2023 2701335619 added role access
Sohel 06/16/2023 2698964415 Changed Fields API in Action and Condition
*/
import {Button, makeStyles, Stepper, StepLabel, Step} from '@material-ui/core';
import React, {useEffect, useRef, useState} from 'react';
import reusableInputStyles from '../../../../../components/InputStyles';
import {backButtonText, downloadButton} from '../../../../../util/Content';
import {ArrowBack} from '@material-ui/icons';
import StepConnector from '@material-ui/core/StepConnector';
import {withStyles} from '@material-ui/core/styles';
import IMRGBasicInfo from './IMRGBasicInfo';
import MapRecordGroups from './MapRecordGroups';
import {useDispatch, useSelector} from 'react-redux';
import useUnsavedChangesWarning from './../../../../../util/CustomHooks';
import {setAlertData} from '../../../../../redux/reducers/UnsavedChangesAlertReducer';
import {
  postPrintImportRecordGroup,
  resetConfigUrl,
  resetDockey,
} from '../../../../../redux/reducers/DataManagerRecordGroup';
import moment from 'moment';
import PreprocessorFields from '../../DataManagerRecord/AddDataManagerRecord/DMRFieldSelect';
import PreprocessorGroup from './PreprocessorGroup';
import {postPrintUsage} from '../../../../../redux/reducers/printUsage';
import PreviewFileDialog from '../../../../../util/PreviewFileDialog';
import axios from 'axios';
import PageLoader from '../../../../../components/PageLoader';
import {resetDownloadMsg} from '../../../../../redux/reducers/PreviewFileData';
import NumberStepIcon from '../../../../../components/customStepIcon';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stepperIcon: {
    '& .MuiStepLabel-iconContainer': {
      '& .MuiStepIcon-root': {
        width: '35px !important',
        height: '35px !important',
      },
    },
    '& .MuiStepIcon-completed': {
      color: '#056c93',
    },
    '& .MuiStepIcon-active': {
      color: '#056c93',
    },
    '& .MuiStepLabel-labelContainer': {
      '& .MuiTypography-root': {
        fontSize: '1rem',
        fontWeight: 'bold',
      },
    },
  },
}));
const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

const AddImportMRGroup = ({
  setValue,
  exportManagerRecordGroup,
  editExisting,
  exportRecordGroupAccess,
  importRecordGroupAccess,
}) => {
  const stepperClasses = useStyles();
  const classes = reusableInputStyles();
  const showAlertRef = useRef(false);
  const dispatch = useDispatch();
  const {onDirty, onPristine} = useUnsavedChangesWarning();
  const {basicInfoData, isDraftRecordGroup, lastStep, configurationUrl, dockey} = useSelector(
    ({dataManagerRecordGroup}) => dataManagerRecordGroup,
  );
  const type = exportManagerRecordGroup ? 'Export' : 'Import';
  const usageType = exportManagerRecordGroup ? 'EXPORT RECORD GROUP' : 'IMPORT RECORD GROUP';
  const steps = ['Basic Info', 'Map Record', 'Transformation Fields', 'Transformation Group'];

  const [activeStep, setActiveStep] = useState(isDraftRecordGroup === 'N' ? 0 : lastStep);
  const [loading, setIsLoadingDelete] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);

  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };

  useEffect(() => {
    if (configurationUrl) {
      setIsLoadingDelete(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoadingDelete(false);
      }
      readData();
    }
  }, [configurationUrl]);
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    if (showAlertRef.current) {
      dispatch(
        setAlertData({
          showAlert: showAlertRef.current,
          alertCallback: () => {
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
          },
        }),
      );
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const changeDirty = useRef(true);
  const handleDirty = (dirty, isFixed) => {
    if (isFixed === 'fixed') {
      showAlertRef.current = dirty;
      changeDirty.current = false;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
    if (isFixed === 'reset') {
      showAlertRef.current = false;
      changeDirty.current = true;
      onPristine();
    }
    if (changeDirty.current) {
      showAlertRef.current = dirty;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
  };
  const alertProps = {
    showAlertRef,
    handleDirty,
  };

  const getStepContent = (stepIndex) => {
    switch (stepIndex) {
    case 0:
      return (
        <IMRGBasicInfo
          activeStep={activeStep}
          handleNext={handleNext}
          exportManagerRecordGroup={exportManagerRecordGroup}
          exportRecordGroupAccess={exportRecordGroupAccess}
          importRecordGroupAccess={importRecordGroupAccess}
          editExisting={editExisting}
          {...alertProps}
        />
      );
    case 1:
      return (
        <MapRecordGroups
          handleBack={handleBack}
          handleNext={handleNext}
          setValue={setValue}
          exportManagerRecordGroup={exportManagerRecordGroup}
          exportRecordGroupAccess={exportRecordGroupAccess}
          importRecordGroupAccess={importRecordGroupAccess}
          editExisting={editExisting}
          {...alertProps}
        />
      );
    case 2:
      return (
        <PreprocessorFields
          handleBack={handleBack}
          handleNext={handleNext}
          exportManagerRecord={exportManagerRecordGroup}
          managerRecordGroup={true}
          emgAuditFields={'Group'}
          exportRecordGroupAccess={exportRecordGroupAccess}
          importRecordGroupAccess={importRecordGroupAccess}
          editExisting={editExisting}
          {...alertProps}
        />
      );
    case 3:
      return (
        <PreprocessorGroup
          handleBack={handleBack}
          setValue={setValue}
          exportManagerRecord={exportManagerRecordGroup}
          managerRecordGroup={true}
          importRecordGroupAccess={importRecordGroupAccess}
          editExisting={editExisting}
          exportRecordGroupAccess={exportRecordGroupAccess}
          {...alertProps}
        />
      );
    }
  };

  return (
    <>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Import Record Group'}
        name={`${type} Record Group Name`}
        code={basicInfoData?.groupCode}
        description={`${type} Record Group Description`}
        descriptionValue={basicInfoData?.groupDescription}
      />
      <div className="button-table-spacing-mb new-standard-textfields justify-content-between">
        <Button
          variant="outlined"
          type="button"
          className={`search-btn ${classes.buttonRoot}`}
          onClick={() => {
            if (showAlertRef.current) {
              dispatch(
                setAlertData({
                  showAlert: showAlertRef.current,
                  alertCallback: () => {
                    setValue(0);
                  },
                }),
              );
            } else {
              setValue(0);
            }
          }}
        >
          <ArrowBack className="mr-2" />
          {backButtonText}
        </Button>
        {basicInfoData?.groupCode && (
          <div>
            <Button
              type="button"
              variant="outlined"
              className={`mx-1 search-btn`}
              onClick={(event) => {
                dispatch(
                  postPrintUsage({
                    baseCategory: '',
                    code: '',
                    description: '',
                    displayName: '',
                    fileType: '',
                    recordFormatType: '',
                    returnType: '',
                    sourceType: usageType,
                    isDraft: '',
                    search: '',
                    frameworkUsageOrderBy: '',
                    frameworkUsageOrderDerection: '',
                    fieldListOrderBy: '',
                    fieldListOrderDerection: '',
                    category: basicInfoData?.category ? basicInfoData?.category : '',
                    includeAudit: basicInfoData?.includeAudit ? basicInfoData?.includeAudit : '',
                    fieldName: '',
                    repositoryDescription: '',
                    repositoryName: '',
                    repositoryType: '',
                    createdBy: '',
                    groupCode: basicInfoData?.groupCode ? basicInfoData?.groupCode : '',
                    groupType: basicInfoData?.groupType ? basicInfoData?.groupType : '',
                    groupDescription: basicInfoData?.groupDescription ?
                      basicInfoData?.groupDescription :
                      '',
                    createdDate: '',
                  }),
                );
              }}
            >
              Download Configuration Usage
            </Button>
            <Button
              type="button"
              variant="outlined"
              className={`search-btn ml-2 ${classes.buttonRoot}`}
              onClick={() => {
                dispatch(
                  postPrintImportRecordGroup(
                    {
                      groupCode: basicInfoData?.groupCode ? basicInfoData?.groupCode : '',
                      groupType: basicInfoData?.groupType ? basicInfoData?.groupType : '',
                      groupDescription: basicInfoData?.groupDescription ?
                        basicInfoData?.groupDescription :
                        '',
                      createdDate: basicInfoData?.createdDate ?
                        moment(basicInfoData?.createdDate).format('MM/DD/YYYY') :
                        '',
                      orderDirection: '',
                      orderBy: '',
                      isDraft: basicInfoData?.isDraft?.key ? basicInfoData?.isDraft?.key : '',
                      tabType: type,
                      printIndividual: 'Y',
                      category: basicInfoData?.category ? basicInfoData?.category : '',
                      includeAudit: basicInfoData?.includeAudit ? basicInfoData?.includeAudit : '',
                    },
                    type,
                  ),
                );
              }}
            >
              {downloadButton}
            </Button>
          </div>
        )}
      </div>

      <div className={'${classes.root} responsiveStepper'}>
        <Stepper
          activeStep={activeStep}
          connector={<QontoConnector />}
          style={{justifyContent: 'center'}}
        >
          {steps.map((label, index) => (
            <Step
              key={label}
              completed={index < activeStep || index <= basicInfoData?.lastStep}
              style={{cursor: 'pointer'}}
              onClick={() => {
                if (index <= basicInfoData?.lastStep) {
                  if (showAlertRef.current) {
                    dispatch(
                      setAlertData({
                        showAlert: showAlertRef.current,
                        alertCallback: () => {
                          setActiveStep(index);
                        },
                      }),
                    );
                  } else {
                    setActiveStep(index);
                  }
                } else if (index < activeStep) {
                  setActiveStep(index);
                }
              }}
            >
              <StepLabel
                className={`${stepperClasses.stepperIcon} ${
                  activeStep === index ? 'completedCircleStyle' : null
                }`}
                StepIconComponent={NumberStepIcon}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        <div>
          <div style={{padding: '1.2rem 0.5rem'}}>{getStepContent(activeStep)}</div>
        </div>
      </div>
      {loading && <PageLoader />}
    </>
  );
};

export default AddImportMRGroup;
